import React, { Component, Fragment } from 'react';
import { message } from 'antd';
import _ from 'lodash';
import qs from 'query-string';
import { __ } from '@wordpress/i18n';
import $ from 'jquery';
import { isMobileOnly } from 'react-device-detect';

import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import whttp from 'libs/whttp';
import { API_HOST } from 'configs/env';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const Local = _.get(window, 'VC_CONFIG.Locale');
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');

// 前端頁面
export default class FAQUs extends Component {
  state = {
    tabType: 'info',
    query: {
      c: null,
      i: null,
    },
    serviceInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 200, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
  };

  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    this.loadConfig();
    this.loadData(query);
    this.setState({ query: query });
  }

  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = () => {
    const query = AppHelper.getHashParamaters();

    this.setState({ isFetchData: true });

    whttp.sharedGet(
      API_HOST + `/api/v1/questions?page_size=all`,
      null,
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace('/faq');
          return;
        }

        this.setState({ listInfo: data });
      }
    );
  };

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);

  getSearchPath = (query) => {
    return (
      VC_CONFIG.INDEX_URL +
      `/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  render() {
    const faqInfo = _.get(this, 'state.listInfo', {});
    const faq = _.get(faqInfo, 'rows', []);
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    const faqCategories = _.get(options, 'question_categories', []);
    const highlight = query.c || _.get(_.first(faqCategories), 'id');
    const highlightItem = query.i;
    this.refreshPicker();

    return (
      <Fragment>
        <main class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${VC_CONFIG.INDEX_URL}${
                        Local == 'en_US' ? '/en' : ''
                      }`}
                    >
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a href='#'>{__('客服中心', 'cec-plugin-stores')}</a>
                  </li>
                  <li class='breadcrumb-item active' aria-current='page'>
                    {__('常見問題', 'cec-plugin-stores')}
                  </li>
                </ol>
              </nav>
            </div>
            <div class='row no-gutters mx-n3 faq-tab-accrodion'>
              <div class='col-md-4 px-3'>
                <div class='card border-0 shadow-0 h-100'>
                  <div class='card-body p-0'>
                    {_.map(faqCategories, (categoryInfo) => (
                      <div class='list-group'>
                        <a
                          id={categoryInfo.id}
                          class={
                            categoryInfo.id === highlight
                              ? 'list-group-item list-group-item-action active'
                              : 'list-group-item list-group-item-action'
                          }
                          href={`#c=${categoryInfo.id}`}
                        >
                          {(Local == 'zh_TW' ||
                            (Local == 'en_US' && !categoryInfo.name_en)) &&
                            categoryInfo.name &&
                            categoryInfo.name}
                          {Local == 'en_US' &&
                            categoryInfo.name_en &&
                            categoryInfo.name_en}
                        </a>
                        {isMobileOnly && (
                          <div
                            id={`bbbb-${categoryInfo.id}`}
                            style={{
                              display:
                                categoryInfo.id === highlight ? '' : 'none',
                            }}
                          >
                            <div class='card border-0 shadow-0 h-100'>
                              <div class='card-body p-0'>
                                <div class='accordion' id='accordionFAQ'>
                                  {_.map(
                                    faq.filter(
                                      (Info) =>
                                        Info.question_category_id ==
                                        categoryInfo.id
                                    ),
                                    (Info) => (
                                      <div
                                        id={`aaa-${Info.id}`}
                                        class='card shadow-0'
                                      >
                                        <div
                                          class='card-header'
                                          id={`heading-${Info.id}`}
                                        >
                                          <h5 class='mb-0'>
                                            <button
                                              class='btn btn-link'
                                              type='button'
                                              data-toggle='collapse'
                                              data-target={`#collapse-${
                                                Info.id
                                              }`}
                                              aria-controls={`collapse-${
                                                Info.id
                                              }`}
                                              href={`#kkk=${Info.id}`}
                                            >
                                              {(Local == 'zh_TW' ||
                                                (Local == 'en_US' &&
                                                  !Info.title_en)) &&
                                                Info.title}
                                              {Local == 'en_US' &&
                                                Info.title_en &&
                                                Info.title_en}
                                            </button>
                                          </h5>
                                        </div>
                                        <div
                                          class='collapse'
                                          id={`collapse-${Info.id}`}
                                          aria-labelledby={`heading-${Info.id}`}
                                          data-parent='#accordionFAQ'
                                        >
                                          <div class='card-body'>
                                            <p class='p text-dark text-justify'>
                                              {(Local == 'zh_TW' ||
                                                (Local == 'en_US' &&
                                                  !Info.content_en)) && (
                                                <div
                                                  dangerouslySetInnerHTML={{
                                                    __html: Info.content.replace(
                                                      /\\n/g,
                                                      '<br/>'
                                                    ),
                                                  }}
                                                />
                                              )}
                                              {Local == 'en_US' &&
                                                Info.content_en && (
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: Info.content_en.replace(
                                                        /\\n/g,
                                                        '<br/>'
                                                      ),
                                                    }}
                                                  />
                                                )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {!isMobileOnly &&
                _.map(faqCategories, (categoryInfo) => (
                  <div
                    id={`bbbb-${categoryInfo.id}`}
                    class='col-md-8 px-3'
                    style={{
                      display: categoryInfo.id == highlight ? '' : 'none',
                    }}
                  >
                    <div class='card border-0 shadow-0 h-100'>
                      <div class='card-body p-0'>
                        <div class='accordion' id='accordionFAQ'>
                          {_.map(
                            faq.filter(
                              (Info) =>
                                Info.question_category_id == categoryInfo.id
                            ),
                            (Info) => (
                              <div id={`aaa-${Info.id}`} class='card shadow-0'>
                                <div
                                  class='card-header'
                                  id={`heading-${Info.id}`}
                                >
                                  <h5 class='mb-0'>
                                    <button
                                      class='btn btn-link'
                                      type='button'
                                      data-toggle='collapse'
                                      data-target={`#collapse-${Info.id}`}
                                      aria-controls={`collapse-${Info.id}`}
                                      href={`#kkk=${Info.id}`}
                                    >
                                      {(Local == 'zh_TW' ||
                                        (Local == 'en_US' && !Info.title_en)) &&
                                        Info.title}
                                      {Local == 'en_US' &&
                                        Info.title_en &&
                                        Info.title_en}
                                    </button>
                                  </h5>
                                </div>
                                <div
                                  class='collapse'
                                  id={`collapse-${Info.id}`}
                                  aria-labelledby={`heading-${Info.id}`}
                                  data-parent='#accordionFAQ'
                                >
                                  <div class='card-body'>
                                    <p class='p text-dark text-justify'>
                                      {(Local == 'zh_TW' ||
                                        (Local == 'en_US' &&
                                          !Info.content_en)) && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: Info.content.replace(
                                              /\\n/g,
                                              '<br/>'
                                            ),
                                          }}
                                        />
                                      )}
                                      {Local == 'en_US' && Info.content_en && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: Info.content_en.replace(
                                              /\\n/g,
                                              '<br/>'
                                            ),
                                          }}
                                        />
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </main>
      </Fragment>
    );
  }
}

$(function() {
  // accordion 展開時觸發
  $(document).on('show.bs.collapse', '#accordionFAQ .card', function() {
    $('.accordion > .card').removeClass('active');
    $('.accordion .card > .collapse').removeClass('show');
    $(this).addClass('active');
  });

  // accordion 收合時觸發
  $(document).on('hide.bs.collapse', '#accordionFAQ .card', function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    }
  });

  $(document).on('click', '.card-body .list-group a', function() {
    const listGroupEl = $(this).parent();
    const accordionItemEl = isMobileOnly
      ? $(listGroupEl).find('[id^="aaa-"]')
      : $(`#bbbb-${this.id}`).find('[id^="aaa-"]');
    // const accordionFirstItemEl = accordionItemEl.first();

    $('.card-body .list-group a').removeClass('active');
    $(this).addClass('active');

    $("[id^='bbbb-']").attr('style', 'display:none');
    $('#bbbb-' + $(this)[0].id).show();

    $("[id^='aaa-']").removeClass('active');
    // accordionFirstItemEl.addClass('active');

    $("[id^='aaa-'] .collapse").removeClass('show');
    // accordionFirstItemEl.children('.collapse').addClass('show');

    if (isMobileOnly) {
      const navbarHeight = $('.navbar').height();
      window.scrollTo({
        top: window.scrollY + this.getBoundingClientRect().top - navbarHeight,
      });

      // 為 mobile, tablet 吃不到 .active 的 style 而設定
      $('.card-body .list-group a').css({ color: '#0E3368' });
      $(this).css({ color: '#fff' });
    }
  });
});

// 編輯器
export class FAQUsEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/customer-service/faq-us.js